const name = 'circle-h';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path fill="#FFF" d="M25.49 55.086h-5.634V26.914h5.634v11.269h11.02V26.914h5.634v28.172H36.51V42.823H25.49z"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'H',
};

export default icon;
